'use es6';

import { createAction } from 'redux-actions';
import { TICKET_STATUS_CHANGED } from '../constants/actionTypes';

/** Ticket status changed via ticket stage dropdown */
export const ticketStageUpdated = createAction(TICKET_STATUS_CHANGED);